import { splitTestActions } from 'wanderu-ducks-split-test';
import Logger from 'wanderu-logger';

import {
    setCityToCityData,
    setSelectedTimeTableDate as setSelectedTimeTableDateAction,
} from '../../appstate/cityToCity/actions';
import { getCityToCityData } from '../../services/seoService';
import {
    actions,
    reducer,
    selectors,
    namespace,
} from './base';

const logger = Logger.getLogger(namespace);

function fetchCityToCityData(cityToCityId, params) {
    const {
        fromCity,
        fromRegion,
        mode,
        toCity,
        toRegion,
        locale,
    } = params;

    return async (dispatch) => {
        let error;

        dispatch(actions.startWork(cityToCityId));

        try {
            const { result } = await getCityToCityData({
                departRegion: fromRegion,
                departCity: fromCity,
                arriveRegion: toRegion,
                arriveCity: toCity,
                transMode: mode,
                locale: locale,
            });
            const {
                ab_testing_info: abTestingInfo,
            } = result;

            if (abTestingInfo) {
                abTestingInfo.forEach((abTest) => {
                    dispatch(splitTestActions.addTestParams([{
                        ...abTest,
                        name: abTest.experiment_name,
                        apply_test: true,
                        do_not_track: true,
                    }]));
                });
            }

            return dispatch(setCityToCityData(cityToCityId, result));
        } catch (ex) {
            logger.warn('fetchCityToCityData', ex.message, cityToCityId);

            error = {
                code: ex.code,
                message: 'set city to city failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(cityToCityId, undefined, error));
        }
    };
}

const fetchCityToCitySelectors = {
    ...selectors,
    selectNotFound(appState, cityToCityId) {
        const opStatus = selectors.idSelector(appState, cityToCityId);

        return opStatus && !opStatus.working
            && opStatus.error
            && opStatus.error.code === 'INVALID_CITY_TO_CITY';
    },
};

const fetchCityToCityAction = {
    fetchCityToCityData,
    ...fetchCityToCitySelectors,
};

export {
    fetchCityToCityAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
